import { Component, Prop } from 'vue-property-decorator';
import Vue, { CreateElement, VNode, VNodeData } from 'vue';
import { baseURL } from '@/core/constants';

@Component({
  name: 'Link',
})
export default class Link extends Vue {
  @Prop({ type: String, default: ''}) public readonly html!: string;
  @Prop({ type: Boolean, default: false}) public readonly absolute!: boolean;

  public checkLink(el: Element): HTMLAnchorElement | undefined {
    const collection: HTMLCollectionOf<any> = el.getElementsByTagName('A');
    const anchor: HTMLAnchorElement = collection[0];
    return anchor;
  }

  public mountAnchor() {
    if (!this.$el) { return; }
    const anchor = this.checkLink(this.$el);
    if (anchor) {
      if (this.absolute) {
        anchor.target = '_blank';
        return;
      }
      const url = anchor.pathname;
      anchor.pathname = `/${baseURL}${url}`;
      anchor.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.$router.push(url);
      });
    }
  }

  public mounted() {
    if (this.$el instanceof Comment) { return; }
    this.mountAnchor();
  }

  public updated() {
    this.mountAnchor();
  }

  public render(createElement: CreateElement): VNode | Comment {

    const data: VNodeData = {
      domProps: {
        innerHTML: this.html,
      },
    };

    const comment = document.createComment(' ');

    return !this.html ? comment : createElement('span', data);
  }
}
